import { Component, OnInit } from '@angular/core';
import { ConsultaService } from '../../services/consulta.service';
import { resolve } from 'path';
import { Router } from '@angular/router';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { URL_IMG } from '../../../conf/url.servicios';

declare var jquery: any;
declare var $: any;
declare var bootbox: any;

class ImagenTabla {
  clave: string;
  descripcion: string;
  ruta: string;
  tipo: number;
  id: number;
}

class RelacionImgBlog {
  idImagen: number;
  idBlog: number;
}

class entidadBlog {
  N_ID: number;
  S_TITULO: string;
  S_REDACCION: string;
  S_RUTA: string;
  D_FECHA: "2018-04-23"
  N_ESTATUS: number;
  claveImg: string;
  descripcionImg: string;
  idImagen: number;
}

class Blog {
  id: number;
  titulo: string;
  redaccion: string;
  ruta: string;
}



@Component({
  selector: 'app-administrarblog',
  templateUrl: './administrarblog.component.html',
  styleUrls: ['./administrarblog.component.css']
})
export class AdministrarblogComponent implements OnInit {
  rutaEliminar: string;
  initBlogEdicion(): any {
    this.blogEdicion = new entidadBlog();
    this.blogEdicion.S_RUTA = "";
  }
  rutaImagen = URL_IMG;
  idBlog: any;
  title = "Administración de Blog";
  modalTitle: string;
  blog: Blog;
  blogEdicion: entidadBlog;
  blogs: any = [];
  extension: any = [];
  idImg: any;
  public editor;
  public editorContent = `<h3>I am Example content</h3>`;
  public editorOptions = {
    placeholder: "Ingrese el texto..."
  };



  form: FormGroup;
  loading: boolean = false;

  @ViewChild('fileInput') fileInput: ElementRef;


  constructor(private router: Router, private fb: FormBuilder, private consultaService: ConsultaService) {
    this.createForm();
  }

  /**
   * Image form
   */
  createForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      avatar: null,
      carpeta: "blog"
    });
  }

  /**
   * File change
   * @param event
   */
  onFileChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.get('avatar').setValue({
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        })
      };
    }
  }

  /**
   *
   */
  onSubmit() {
    const formModel = this.form.value;
    this.loading = true;
    console.log(formModel);

    this.consultaService.guardarImagen(formModel).then(resolve => {
      bootbox.alert("<strong>Alerta</strong><br/><br/> Blog agregado correctamente");
    });

    setTimeout(() => {
      console.log(formModel);
      alert('done!');
      this.loading = false;
    }, 1000);
  }

  clearFile() {
    this.form.get('avatar').setValue(null);
    this.fileInput.nativeElement.value = '';
  }


  ngOnInit() {
    if (!this.consultaService.esNuevaSession()) {
      this.initBlog();
      this.initBlogEdicion();
      this.obtieneEntradasBlog();
    }

  }

  onEditorBlured(quill) {
    //console.log('editor blur!', quill);
  }

  onEditorFocused(quill) {
    //console.log('editor focus!', quill);
  }

  onEditorCreated(quill) {
    this.editor = quill;
    //console.log('quill is ready! this is current quill instance object', quill);
  }

  onContentChanged({ quill, html, text }) {
    //console.log('quill content is changed!', quill, html, text);
  }


  initBlog() {
    this.blog = new Blog();
    this.blog.titulo = "";
    this.blog.redaccion = "";
    this.blog.ruta = "";

  }

  initModal(paramBlog) {
    console.log("Init modal blog");
    console.log(paramBlog);
    if (paramBlog == null) {
      this.modalTitle = "Nuevo Blog"
      this.blog = new Blog();
      this.blog.id = null;
      this.blog.redaccion = null;
      this.blog.titulo = null;
    } else {
      this.modalTitle = "Actualizar Blog";
      this.blog.id = paramBlog.N_ID;
      this.blog.redaccion = paramBlog.S_REDACCON;
      this.blog.titulo = paramBlog.S_TITULO;
      this.blog.ruta = paramBlog.S_RUTA;
    }
  }

  initModalEdicion(paramBlog) {
    this.blogEdicion = paramBlog;
  }

  getNewFileName(formParam) {
    var fileNameAux = formParam.avatar.filename;
    this.extension = fileNameAux.split('.').pop();
    var valReplace = "." + this.extension;
    var newFileName = fileNameAux.replace(valReplace, "");
    return newFileName + Date.now() + "." + this.extension;
  }

  guardarBlog() {
    console.log("Datos Blog a editar");
    console.log(this.blog);

    //Adjunta imagen

    var rutaImagen = "";
    const formModel = this.form.value;
    this.loading = true;
    console.log(formModel);
    formModel.avatar.filename = this.getNewFileName(formModel);
    this.consultaService.guardarImagen(formModel).then(resolve => {
      console.log(resolve);
      if (resolve) {
        rutaImagen = this.consultaService.rutaImagen;
        //Guarda ruta imagen en tabla
        var imgTbl = new ImagenTabla();
        imgTbl.clave = "";
        imgTbl.descripcion = formModel.name;
        imgTbl.ruta = rutaImagen;
        imgTbl.tipo = 1;
        this.consultaService.guardaImagenTabla(imgTbl).then(resolve => {
          this.idImg = this.consultaService.idImg;
                    //Guarda blog

          if (this.blog.id == null) {
            console.log("Nuevo");
            this.consultaService.guardarBlog(this.blog).then(resolve => {
              this.idBlog = this.consultaService.idBlog;
              //Guarda la relacion imagen-blog
              var rel = new RelacionImgBlog();
              rel.idBlog = this.idBlog;
              rel.idImagen = this.idImg;
              this.consultaService.guardaRelacionImgBlog(rel).then(resolve => {
                this.obtieneEntradasBlog();
                bootbox.alert("<strong>Alerta</strong><br/><br/> Información guardada correctamente");
              });

            });
          }

        });
      } else {
        alert('Ocurrió un error al subir la imagen, favor de intentar nuevamente');
      }

    });
  }

  /**
   * Obtiene una lista con las entradas del blog
   */
  obtieneEntradasBlog() {
    this.blogs = [];
    this.consultaService.obtieneEntradasBlog().then(resolve => {
      this.blogs = this.consultaService.entradasBlog;
    });
  }

  cambiarImagen() {
    this.rutaEliminar = this.blogEdicion.S_RUTA;
    this.blogEdicion.S_RUTA = "";
  }

  isValidForm() {
    var valido = true;
    const formModel = this.form.value;

    if (formModel.name.length == 0 || formModel.avatar == null) {
      valido = false;
    }
    return valido;
  }

  actualizarImagen() {

    console.log("Editar");

    //Adjunta imagen

    var rutaImagen = "";
    const formModel = this.form.value;
    this.loading = true;
    console.log(formModel);
    formModel.avatar.filename = this.getNewFileName(formModel);

    //Borra ruta del servidor

    this.consultaService.borraImagen(this.rutaEliminar);

    //adjunta la imagen

    this.consultaService.guardarImagen(formModel).then(resolve => {
      console.log(resolve);
      if (resolve) {

        rutaImagen = this.consultaService.rutaImagen;

        //Guarda ruta imagen en tabla

        var imgTbl = new ImagenTabla();
        imgTbl.clave = "";
        imgTbl.descripcion = formModel.name;
        imgTbl.ruta = rutaImagen;
        imgTbl.tipo = 1;
        imgTbl.id = this.blogEdicion.idImagen;
        this.consultaService.actualizaImagenTabla(imgTbl).then(resolve => {
          bootbox.alert("<strong>Alerta</strong><br/><br/> Información guardada correctamente");

        });
      }
    });

  }

  actualizarBlog() {
    this.consultaService.actualizaBlog(this.blogEdicion).then(resolve => {
      this.idBlog = this.consultaService.idBlog;
      bootbox.alert("<strong>Alerta</strong><br/><br/> Información guardada correctamente");
      this.obtieneEntradasBlog();
    });
  }

  eliminaBlog(item:any){
//console.log(item);
    bootbox.confirm({
        message: "¿Desea eliminar permanentemente este blog?",
        buttons: {
            confirm: {
                label: 'Si',
                className: 'btn-success'
            },
            cancel: {
                label: 'No',
                className: 'btn-danger'
            }
        },
        callback: function (result) {
          if(result){
            $("#borraBlogF_"+item.N_ID).click();
          }

        }
    });


  }

  eliminaBlogF(item:any){
    console.log(item);
     this.consultaService.eliminarBlog(item).then(resolve => {
          bootbox.alert("<strong>Alerta</strong><br/><br/> Información borrada correctamente");
          this.obtieneEntradasBlog();
        });


  }

}//end class



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/components/administrarblog/administrarblog.component.ts